import {
  ContractTypeArray,
  type ContractType
} from '@libs/data-access/entities'

const ValidContractTypes = ContractTypeArray.filter(type =>
  ['CDI', 'CDD', 'interim', 'apprentissage', 'extra'].includes(type)
).map(type => type.toLowerCase())

export const isMemberValidForRTT = ({
  contract_type,
  contract_time,
  isDailyWorker
}: {
  contract_type: ContractType | null
  contract_time: number | null
  isDailyWorker: boolean
}) => {
  if (isDailyWorker) {
    return true
  }

  if (
    contract_type &&
    contract_time &&
    ValidContractTypes.includes(contract_type.toLowerCase()) &&
    contract_time >= 35
  ) {
    return true
  }
  return false
}
